import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BzgModalService, BzgModalRef } from 'bz-genome-angular';
import { IKBCatalog, IKBCatalogCategory } from '../interfaces/IBase-knowledge-catalog';
import { AddArtifactModalComponent } from '../add-artifact-modal/add-artifact-modal';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import { I18nService } from 'i18n/i18n.service';

export interface ModalConfig {
  closeOnBackdropClick?: boolean;
  width?: string;
  maxWidth?: string;
  maxHeight?: string;
  closeOnRouterNavigation?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ModalOperationsService {

  private readonly defaultModalConfig: ModalConfig = {
    closeOnBackdropClick: false,
    width: '80%',
    maxWidth: 'none',
    maxHeight: '90%',
    closeOnRouterNavigation: true
  };

  constructor(
    private _modalService: BzgModalService,
    private _i18nService: I18nService
  ) { }


  openArtifactModal(catalog?: IKBCatalog, config?: ModalConfig): Observable<any> {
    const modal = this._modalService.open(AddArtifactModalComponent, {
      ...this.defaultModalConfig,
      ...config,
      data: catalog
    });

    return modal.afterClosed();
  }

  openDeleteConfirmationModal(catalog: IKBCatalog): Observable<any> {
    const title = `${this._i18nService.instant('GLOBAL.DELETE')} - ${catalog.DisplayName}`;
    const modal = this._modalService.open(DeleteConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: { 
        title, 
        message: 'BASEKNOWLEDGECATALOG.CONFIRM_DELETE_CATALOG', 
        button: 'GLOBAL.DELETE' 
      }
    });

    return modal.afterClosed();
  }
}
